// extracted by mini-css-extract-plugin
export default {"RewardContainer":"Menu_RewardContainer__ZytcN","InnerContainer":"Menu_InnerContainer__FxsHH","PrimaryLargeText":"Menu_PrimaryLargeText__x+Non","RewardText":"Menu_RewardText__Crr1z"};